<template>
  <div class="input-group" :class="{ 'input-group-sm': isSmall }">
    <slot></slot>
    <svg-icon v-if="isClearDate" class="inside-el" style="right: 50px; transform: translateY(50%);" :name="'cross'"
      :width="18" :height="18" @click:icon="clearDate"></svg-icon>
    <div class="input-group-append" @click="clickIcon">
      <span class="input-group-text bg-primary icon icon-calendar" data-testid="span-btn-calendar"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCalendarWrap',
  components: {
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  props: {
    isSmall: {
      type: Boolean,
      required: false,
      default: false
    },
    isClearDate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({}),
  computed: {},
  methods: {
    // Получаем первый компонент из слота
    getSlotComponent() {
      if (this.$slots.default && this.$slots.default[0] && this.$slots.default[0].componentInstance) {
        return this.$slots.default[0].componentInstance
      }

      return null
    },

    clickIcon() {
      const child = this.getSlotComponent()
      if (child && typeof child.openPicker === 'function') {
        child.openPicker()
      } else {
        console.warn('Child component does not have openPicker method')
      }
    },

    clearDate() {
      const child = this.getSlotComponent()
      if (child && typeof child.clearValue === 'function') {
        child.clearValue()
      } else {
        console.warn('Child component does not have clearValue method')
      }
    }
  }
}
</script>
